/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nav-item.logged-in[_ngcontent-%COMP%]{text-align:right;margin-bottom:-10px}.nav-item.logged-in[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding-top:0}.nav-item.logged-in[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#282828;padding-right:10px}"];
export { styles as styles };
